<template>
    <b-card>
        <b-row>
            <b-col lg="6">
                <b-btn variant="info" @click="createActivity()">Add Activity</b-btn>
            </b-col>
            <b-col lg="6" class="text-right">
                <b-form-input v-model="filter" placeholder="Type to Search" />
            </b-col>
        </b-row>

        <div class="table-responsive pt-2">
            <b-table bordered striped hover show-empty
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
            >
                <template v-slot:cell(options)="row">
                    {{ row.item.options.join(', ' ) }}
                </template>
                <template v-slot:cell(actions)="row">
                    <b-btn variant="info" size="sm" @click="edit(row.item)">
                        <i class="fa fa-edit"></i>
                    </b-btn>
                    <b-btn variant="danger" size="sm" @click="destroy(row.item)">
                        <i class="fa fa-times"></i>
                    </b-btn>
                </template>
            </b-table>
        </div>

        <b-row>
            <b-col lg="6" >
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
            </b-col>
            <b-col lg="6" class="text-right">
                Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
            </b-col>
        </b-row>

        <b-modal id="activityModal" :title="modalTitle" v-model="activityModal">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <b-form-group label="Activity Code" label-for="code">
                            <b-form-input
                                id="code"
                                name="code"
                                type="text"
                                v-model="form.code"
                                >
                            </b-form-input>
                            <input-help :form="form" field="code" text="Enter a numerical code for this activity."></input-help>
                        </b-form-group>
                        <b-form-group label="Activity Name" label-for="name">
                            <b-form-input
                                id="name"
                                name="name"
                                type="text"
                                v-model="form.name"
                                >
                            </b-form-input>
                            <input-help :form="form" field="name" text="Enter the display name for this activity."></input-help>
                        </b-form-group>

                        <b-form-group label="Options">
                            <b-row v-for="(option, index) in form.options" :key="index" class="pb-2">
                                <b-col lg="10">
                                    <b-form-input name="option[]" type="text" v-model="form.options[index]" />
                                </b-col>
                                <b-col lg="2">
                                    <b-btn variant="danger" size="sm" @click="removeOption(index)">
                                        <i class="fa fa-times"></i>
                                    </b-btn>
                                </b-col>
                            </b-row>

                            <b-btn variant="primary" size="sm" @click="addOption()">
                                <i class="fa fa-plus"></i> Add Option
                            </b-btn>
                        </b-form-group>
                    </b-col>
               </b-row>
            </b-container>
            <div slot="modal-footer">
               <b-btn variant="default" @click="activityModal=false">Close</b-btn>
               <b-btn variant="danger" @click="deleteActivity()" v-if="selectedItem.id">Delete</b-btn>
               <b-btn variant="info" @click="saveActivity()">Save</b-btn>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
export default {
    props: {
        activities: {}
    },

    data() {
        return {
            totalRows: 0,
            perPage: 15,
            currentPage: 1,
            sortBy: 'name',
            sortDesc: false,
            filter: null,
            activityModal: false,
            selectedItem: {},
            form: new Form({
                code: null,
                name: null,
                options: ['Yes', 'No'],
            }),
            fields: [
                {
                    key: "name",
                    label: "Activity Name",
                    sortable: true
                },
                {
                    key: "options",
                    class: "hidden-print"
                },
                { key: 'actions' },
            ],
            items: this.activities
        };
    },

    mounted() {
        this.totalRows = this.items.length;
    },

    computed: {
        modalTitle() {
            if (this.selectedItem.id) {
                return "Edit Activity";
            }
            return "Create Activity";
        }
    },

    methods: {
        edit(activity) {
            this.selectedItem = JSON.parse(JSON.stringify(activity));
            this.form = new Form({
                code: this.selectedItem.code,
                name: this.selectedItem.name,
                options: this.selectedItem.options,
            });
            this.activityModal = true;
        },
        destroy(activity) {
            if (! confirm(`Are you sure you want to delete the activity '${activity.name}'?  This cannot be undone.`)) {
                return;
            }

            let form = new Form();
            form.submit('delete', `/business/activities/${activity.id}`)
                .then(response => {
                    let index = this.items.findIndex(item => item.id == activity.id);

                    if (index) {
                        this.items.splice(index, 1);
                    }
                })
        },
        removeOption(index) {
            this.form.options.splice(index, 1);
        },
        addOption() {
            this.form.options.push('');
        },
        createActivity() {
            this.selectedItem = {};
            this.form = new Form({
                code: null,
                name: null,
                options: ['Yes', 'No'],
            });
            this.activityModal = true;
        },
        saveActivity() {
            var component = this;
            if (component.selectedItem.id) {
                component.form
                    .patch("/business/activities/" + component.selectedItem.id)
                    .then(function(response) {
                        component.activityModal = false;
                        component.items.map(function(activity) {
                            if (activity.id == component.selectedItem.id) {
                                activity.code = component.form.code;
                                activity.name = component.form.name;
                                activity.options = component.form.options;
                            }
                            return activity;
                        });
                    });
            } else {
                component.form.post("/business/activities").then(function(response) {
                    component.activityModal = false;
                    component.items.push({
                        id: response.data.data.id,
                        code: component.form.code,
                        name: component.form.name,
                        options: component.form.options
                    });
                });
            }
        },
        deleteActivity() {
            if (confirm("Are you sure you wish to delete this activity?")) {
                let component = this;
                let form = new Form();
                form.submit("delete", "/business/activities/" + component.selectedItem.id)
                    .then(function(response) {
                        component.items = component.items.filter(
                            activity => activity.id != component.selectedItem.id
                        );
                        component.activityModal = false;
                    });
            }
        },
        resetModal() {
            this.modalDetails.data = "";
            this.modalDetails.index = "";
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    }
};
</script>